import { z, isoZ } from 'my-zod'

const OrderStatusEnum = z.enum(['InProcess', 'Ordered', 'Shipped'])
export const OrderStatuses = OrderStatusEnum.Values
export type OrderStatus = z.infer<typeof OrderStatusEnum>

export const outfitterOrderHeadersModel = z.object({
  id: z.number(),
  shortId: z.string(),
  outfitterId: z.number(),
  contractedStartDate: isoZ.date().nullable(),
  contractedEndDate: isoZ.date().nullable(),
  quoteNumber: z.string().nullable(),
  orderStatus: OrderStatusEnum.nullable(),
  earliestShipDate: isoZ.date().nullable(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable()
})

export type outfitterOrderHeadersModel = z.infer<typeof outfitterOrderHeadersModel>
